import useEffect from '../useEffect';
import useState from '../useState';
/**
 *
 * @param {boolean} initialState - whether to show the loading component when the page inits
 * @returns
 */
export function useApiLoadingPool(initialState) {
    const [isLoading, setLoading] = useState(initialState);
    const [apiProcessingPool, setApiProcessingPool] = useState([]);
    const [apiDonePool, setApiDonePool] = useState([]);
    // #NOTES
    // If we call APIs when the page inits (after the page is mounted), the initial loading state
    // can be set to true, and then be automatically set to false after all the APIs are done.
    // Otherwise, the initialState is set to false to prevent the page from infinite loading.
    // (e.g., the Contract page).
    useEffect(() => {
        if (apiProcessingPool.length === 0 || apiDonePool.length === 0)
            return;
        if (apiProcessingPool.length <= apiDonePool.length)
            setLoading(false);
        else
            setLoading(true);
    }, [apiProcessingPool, apiDonePool]);
    return {
        isLoading,
        setLoading,
        setApiProcessingPool,
        setApiDonePool,
    };
}
